import { useMutation, useQuery, useQueryClient } from '@tanstack/react-query';
import { api } from '@/lib/api';

// The browser's own time zone and language, sent only as a hint for the
// suggestion on a brand-new workspace. The server never stores them.
export function browserHint() {
  let tz = '';
  try { tz = Intl.DateTimeFormat().resolvedOptions().timeZone || ''; } catch (_e) { /* none */ }
  const locale = (typeof navigator !== 'undefined' && navigator.language) || '';
  return { tz, locale };
}

/**
 * The workspace's currency as the server decides it (services/workspaceCurrency):
 * { currency, confirmed, source, suggestion: { currency, source, reason },
 *   orders: { total, by, other, other_count }, offered: [{ code, name }] }
 */
export function useWorkspaceCurrency({ withHint = false, enabled = true } = {}) {
  return useQuery({
    queryKey: ['workspace-currency', withHint],
    queryFn: async () => {
      const params = withHint ? browserHint() : {};
      return (await api.get('/api/settings/currency', { params })).data;
    },
    staleTime: 60_000,
    retry: false,
    enabled,
  });
}

/** The one write: POST /api/settings/currency. Relabels, never converts. */
export function useChooseCurrency() {
  const qc = useQueryClient();
  return useMutation({
    mutationFn: async (currency) => (await api.post('/api/settings/currency', { currency })).data,
    onSuccess: () => {
      qc.invalidateQueries({ queryKey: ['workspace-currency'] });
      // The shell reads display.currency from here and re-renders every page
      // with the new label (App.js keys the routes on it).
      qc.invalidateQueries({ queryKey: ['org-settings'] });
    },
  });
}
